module.exports = "/_next/static/images/d3eba1211987ed517129fcac0b957ddb-girl-with-card-lg.png.webp";